const v = typeof window.requestIdleCallback == "function" ? window.requestIdleCallback : setTimeout,
  L = typeof window.cancelIdleCallback == "function" ? window.cancelIdleCallback : clearTimeout;
function D(t, e) {
  let n;
  function o(...r) {
    (clearTimeout(n), (n = setTimeout(() => t.apply(this, r), e)));
  }
  return (
    (o.cancel = () => {
      clearTimeout(n);
    }),
    o
  );
}
function I(t, e, n = { subtree: !0 }) {
  const r = (Array.isArray(t) ? t.flatMap((s) => s.getAnimations(n)) : t.getAnimations(n)).reduce(
    (s, i) => (i.timeline instanceof DocumentTimeline && s.push(i.finished), s),
    []
  );
  return Promise.allSettled(r).then(e);
}
const M = matchMedia("(prefers-reduced-motion: reduce)");
function H() {
  return M.matches;
}
function $(t) {
  const e = document.createElement("div");
  return ((e.textContent = t), e.innerHTML);
}
function P(t, e) {
  let n = 0;
  return function (...o) {
    const r = Date.now();
    if (r - n >= e) return ((n = r), t.apply(this, o));
  };
}
function F(t, { locale: e = "de-DE", currency: n = "EUR" } = {}) {
  if (typeof t != "number" || isNaN(t)) return "";
  const o = t / 100;
  return new Intl.NumberFormat(e, {
    style: "currency",
    currency: n,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(o);
}
function O(t, e) {
  customElements.get(t) || customElements.define(t, e);
}
class T extends HTMLElement {
  connectedCallback() {
    if (!this.shadowRoot) {
      const e = this.querySelector(':scope > template[shadowrootmode="open"]');
      if (!(e instanceof HTMLTemplateElement)) return;
      (this.attachShadow({ mode: "open" }).append(e.content.cloneNode(!0)), e.remove());
    }
  }
}
class q extends Error {
  constructor(e, n) {
    super(`Required ref "${e}" not found in component ${n.tagName.toLowerCase()}`);
  }
}
class p extends T {
  refs = {};
  requiredRefs;
  observeRefChanges = !1;
  #e;
  #t;
  get roots() {
    return this.shadowRoot ? [this, this.shadowRoot] : [this];
  }
  get signal() {
    return (this.#e || (this.#e = new AbortController()), this.#e.signal);
  }
  connectedCallback() {
    (super.connectedCallback(),
      x(),
      this.#n(),
      this.observeRefChanges &&
        (this.#t = v(() => {
          if (this.isConnected)
            for (const e of this.roots)
              this.#r.observe(e, {
                childList: !0,
                subtree: !0,
                attributes: !0,
                attributeFilter: ["ref"],
                attributeOldValue: !0,
              });
        })));
  }
  updatedCallback() {
    (this.#r.takeRecords(), this.#n());
  }
  disconnectedCallback() {
    (this.#t !== void 0 && (L(this.#t), (this.#t = void 0)),
      this.#r.disconnect(),
      this.#e?.abort(),
      (this.#e = void 0));
  }
  #n() {
    const e = {},
      n = this.roots.reduce((o, r) => {
        for (const s of r.querySelectorAll("[ref]")) this.#o(s) && o.add(s);
        return o;
      }, new Set());
    for (const o of n) {
      const r = o.getAttribute("ref") ?? "",
        s = r.endsWith("[]"),
        i = s ? r.slice(0, -2) : r;
      if (s) {
        const a = Array.isArray(e[i]) ? e[i] : [];
        (a.push(o), (e[i] = a));
      } else e[i] = o;
    }
    if (this.requiredRefs?.length) {
      for (const o of this.requiredRefs) if (!(o in e)) throw new q(o, this);
    }
    this.refs = e;
  }
  #r = new MutationObserver((e) => {
    e.some(
      (n) =>
        (n.type === "attributes" && this.#o(n.target)) ||
        (n.type === "childList" && [...n.addedNodes, ...n.removedNodes].some(this.#o))
    ) && this.#n();
  });
  #o = (e) => m(N(e)) === this;
}
function N(t) {
  if (t.parentNode) return t.parentNode;
  const e = t.getRootNode();
  return e instanceof ShadowRoot ? e.host : null;
}
function m(t) {
  if (!t) return null;
  if (
    t instanceof p ||
    (t instanceof HTMLElement && t.tagName.toLowerCase().endsWith("-component"))
  )
    return t;
  const e = N(t);
  return e ? m(e) : null;
}
let R = !1;
function x() {
  if (R) return;
  R = !0;
  const t = [
      "click",
      "change",
      "select",
      "focus",
      "blur",
      "submit",
      "input",
      "keydown",
      "keyup",
      "toggle",
    ],
    e = ["focus", "blur"],
    n = ["pointerenter", "pointerleave"];
  for (const r of [...t, ...n]) {
    const s = `on:${r}`;
    document.addEventListener(
      r,
      (i) => {
        const a = o(i);
        if (!a) return;
        const A =
            i.target !== a
              ? new Proxy(i, {
                  get(c, E) {
                    if (E === "target") return a;
                    const h = Reflect.get(c, E);
                    return typeof h == "function" ? h.bind(c) : h;
                  },
                })
              : i,
          b = a.getAttribute(s) ?? "",
          g = b.split("/"),
          u = g[0];
        let l = g[1];
        const w = b.match(/([\/\?][^\/\?]+)([\/\?][^\/\?]+)$/),
          y = w ? w[2] : null,
          f = u && u !== "" ? (u.startsWith("#") ? document.querySelector(u) : a.closest(u)) : m(a);
        if (!f || !l) return;
        const d = f instanceof p ? f : m(f);
        if (!d || !(d instanceof p) || !l) return;
        l = l.replace(/\?.*/, "");
        const C = d[l];
        if (typeof C == "function")
          try {
            const c = [A];
            (y && c.unshift(S(y)), C.call(d, ...c));
          } catch (c) {
            console.error(c);
          }
      },
      { capture: !0 }
    );
  }
  function o(r) {
    const s = r.composedPath?.()[0] ?? r.target;
    if (s instanceof Element)
      return s.hasAttribute(`on:${r.type}`)
        ? s
        : n.includes(r.type)
          ? null
          : r.bubbles || e.includes(r.type)
            ? s.closest(`[on\\:${r.type}]`)
            : null;
  }
}
function S(t) {
  const e = t[0],
    n = t.slice(1);
  return e === "?"
    ? Object.fromEntries(Array.from(new URLSearchParams(n).entries()).map(([o, r]) => [o, k(r)]))
    : k(n);
}
function k(t) {
  if (t === "true") return !0;
  if (t === "false") return !1;
  const e = Number(t);
  return !isNaN(e) && t.trim() !== "" ? e : t;
}
export { p as C, D as a, O as d, $ as e, F as f, I as o, H as p, v as r, P as t };
